import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {endOfWeek, startOfWeek} from 'date-fns';

export const setFilters = createAsyncThunk(
  'timesheetFilters/setFilters',
  async (args: any) => {
    return args;
  },
);

const timesheetFilters = createSlice({
  name: 'timesheetFilters',
  initialState: {
    selectedFilters: {
      startDate: startOfWeek(new Date()).getTime(),
      endDate: endOfWeek(new Date()).getTime(),
      allTime: [],
      staff: [],
      clients: [],
      locations: [],
      types: [],
      status: ['completed', 'non-clinical'],
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setFilters.fulfilled, (state, {payload}) => {
      Object.assign(state, {selectedFilters: payload});
    });
  },
});

export default timesheetFilters.reducer;
